import { useMemo } from 'react';
import { getIntl } from 'umi';
import { Table, TableAddon } from 'tea-component';
import { DEFAULT_SIZE_OPTIONS } from '../constants';

import type { PageableOptions } from 'tea-component/es/table/addons';

const { pageable } = Table.addons;

/**
 * useTablePageableAddon hooks的props类型
 */
interface IUseTablePageableAddon extends PageableOptions {
  /**
   * 是否加载数据中
   */
  loading?: boolean;
}

const getStateText = (total?: any): string => {
  const { formatMessage } = getIntl();
  let totalNum = Number.parseInt(total, 10);
  if (Number.isNaN(totalNum)) {
    totalNum = 0;
  }
  return formatMessage({ id: 'dbi_pagination_total' }, { total: totalNum });
};

export default function useTablePageableAddon<T = any>(props: IUseTablePageableAddon) {
  const { loading = true, recordCount, pageSizeOptions = DEFAULT_SIZE_OPTIONS, ...restProps } = props;

  const pageableAddon = useMemo<TableAddon<T>>(() => {
    const minPageSize = Math.min(...(pageSizeOptions || []));
    const isLessThanOnePage = !recordCount || recordCount <= minPageSize;

    return pageable({
      ...restProps,
      recordCount,
      stateText: getStateText(loading ? 0 : recordCount),
      pageSizeVisible: !loading && !isLessThanOnePage,
      pageSizeOptions,
      pageIndexVisible: !loading && !isLessThanOnePage,
      jumpVisible: !loading && !isLessThanOnePage,
      endJumpVisible: !loading && !isLessThanOnePage,
    });
  }, [loading, recordCount, pageSizeOptions, restProps]);

  return pageableAddon;
}
